import React, { useState, useEffect } from 'react';
import './LoadingBar.css';
import { krPhrases } from '../utils';

const LoadingBar = ({ dur }) => {
  const [progress, setProgress] = useState(0);
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

  useEffect(() => {
    const duration = parseInt(dur, 10) || 10;
    const interval = (duration * 1000) / 100;

    const timer = setInterval(() => {
      if (progress < 100) {
        setProgress(prevProgress => prevProgress + 1);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [progress, dur]);

  useEffect(() => {
    const phraseTimer = setTimeout(() => {
      setCurrentPhraseIndex(prevIndex => (prevIndex + 1) % krPhrases.length);
    }, 4000); // Change phrase every 2 seconds

    return () => clearTimeout(phraseTimer);
  }, [currentPhraseIndex]);

  return (
    <div className="loading-bar-wrapper">
      <div className="loading-bar-container">
        <div className="loading-bar" style={{ width: `${progress}%` }} />
      </div>
      <p className="loading-message">{krPhrases[currentPhraseIndex]}</p>
    </div>
  );
};

export default LoadingBar;